import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AwardCardsComponent } from '../award-cards/award-cards.component';

@Component({
    selector: 'app-awards',
    standalone: true,
    imports: [CommonModule, TranslateModule, AwardCardsComponent],
    templateUrl: './awards.component.html',
    styleUrl: './awards.component.scss',
})
export class AwardsComponent implements OnInit, OnDestroy {
    allAwards = [
        {
            id: 1001,
            titleKey: 'AWARDS.CARDS.NATIONAL_BUSINESS_AWARDS_2025.TITLE',
            descriptionKey: 'AWARDS.CARDS.NATIONAL_BUSINESS_AWARDS_2025.DESCRIPTION',
            image: '/assets/images/logo/AWARDS_BNM.svg',
        },
        {
            id: 1002,
            titleKey: 'AWARDS.CARDS.MALAYSIA_TECH_EXCELLENCE_2025.TITLE',
            descriptionKey: 'AWARDS.CARDS.MALAYSIA_TECH_EXCELLENCE_2025.DESCRIPTION',
            image: '/assets/images/logo/AWARDS_MYTEA.svg',
        },
    ];

    currentScreenSize: 'sm' | 'md' | 'lg' = 'lg';
    currentRowsToShow = 1;

    itemsPerRow = {
        sm: 1, // mobile: 1 item per row
        md: 3, // tablet: 3 items per row
        lg: 4, // desktop: 4 items per row
    };

    // Initial rows to show for each screen size
    initialRows = {
        sm: 2, // mobile: show 2 rows initially
        md: 1, // tablet: show 1 row initially
        lg: 1, // desktop: show 1 row initially
    };

    get awards() {
        const itemsToShow =
            this.currentRowsToShow * this.itemsPerRow[this.currentScreenSize];
        return this.allAwards.slice(0, itemsToShow);
    }

    get hasMoreAwards() {
        const itemsToShow =
            this.currentRowsToShow * this.itemsPerRow[this.currentScreenSize];
        return this.allAwards.length > itemsToShow;
    }

    private resizeListener?: () => void;

    constructor() {
        console.log('awards');
    }

    ngOnInit() {
        this.detectScreenSize();
        this.setInitialRows();
        this.setupResizeListener();
    }

    ngOnDestroy() {
        if (this.resizeListener && typeof window !== 'undefined') {
            window.removeEventListener('resize', this.resizeListener);
        }
    }

    private detectScreenSize() {
        if (typeof window !== 'undefined') {
            const width = window.innerWidth;
            if (width < 768) {
                this.currentScreenSize = 'sm';
            } else if (width < 1024) {
                this.currentScreenSize = 'md';
            } else  {
                this.currentScreenSize = 'lg';
            }
        }
    }

    private setInitialRows() {
        this.currentRowsToShow = this.initialRows[this.currentScreenSize];
    }

    private setupResizeListener() {
        if (typeof window !== 'undefined') {
            this.resizeListener = () => {
                const previousScreenSize = this.currentScreenSize;
                this.detectScreenSize();

                // Reset rows when screen size changes to maintain proper display
                if (previousScreenSize !== this.currentScreenSize) {
                    this.setInitialRows();
                }
            };
            window.addEventListener('resize', this.resizeListener);
        }
    }

    viewMore() {
        if (this.currentScreenSize === 'sm') {
            this.currentRowsToShow += 2; // Mobile: add 2 rows (2 cards)
        } else {
            this.currentRowsToShow += 1; // Tablet/Desktop: add 1 row
        }
    }
}
